import React, { Fragment, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import FocusLock from 'react-focus-lock';
import PreviewItem from 'legacy/src/utility/PreviewItem';
import { questionBankPreviewConfig } from 'legacy/src/components/learnosity/utils/config';
import ScreenModal from 'chameleon/ui-stack/ui/modals/screen-modal';
import Button from 'chameleon/ui-stack/ui/base/button';
import QuestionNavigation from 'legacy/src/components/questionBank/QuestionNavigation';
import ItemTitleWithIcons from 'legacy/src/components/questionBank/ItemTitleWithIcons';
import { APTopicQuestionIcon } from 'legacy-src/utility';
import CreateModal from 'legacy-src/components/questionBank/QuizBuilder/components/BrowseQuestions/CreateModal';

const TopicQuestionPreview = (props) => {
  const { items, itemIds, router, params, onCreateQuiz, blueBookUiFlag } =
    props;
  const { subject, previewId } = params;
  const { location } = router;
  const { query } = location;
  const [showCreateModal, setShowCreateModal] = useState(false);
  const quizTitle = useRef(null);
  const showGrayTopRightBarPreview = true;
  const [currentPreviewId, setCurrentPreviewId] = useState(
    Number.parseInt(previewId, 10),
  );
  const getCurrentItem = (items, previewId) =>
    items &&
    items.find((item) => parseInt(item.itemId, 10) === parseInt(previewId, 10));
  const currentItem = getCurrentItem(items, currentPreviewId) || {};

  const onUrlUpdate = (itemId) => {
    setCurrentPreviewId(Number.parseInt(itemId, 10));
  };

  const { title } = currentItem || {};

  const submitCreateModal = () => {
    onCreateQuiz &&
      onCreateQuiz({
        title: quizTitle.current,
      });
  };
  const closeCreateModal = () => {
    setShowCreateModal(false);
  };
  const onTitleChange = (newTitle) => {
    quizTitle.current = newTitle;
  };

  const onItemChange = (itemId) => {
    setCurrentPreviewId(Number.parseInt(itemId, 10));
  };

  const previewTitle = (
    <Fragment>
      {!showGrayTopRightBarPreview && (
        <div className="question__title">{title}</div>
      )}
      {showGrayTopRightBarPreview && (
        <span className="question-text font-medium">{`Q: ${title}`}</span>
      )}
    </Fragment>
  );

  const previewSubTitle = (
    <ItemTitleWithIcons
      item={currentItem}
      iconsMap={{
        is_topic_question: (
          <APTopicQuestionIcon popoverClass="lightbulb--yellow" />
        ),
      }}
    />
  );

  const previewTopBar = (
    <Button
      isPrimary
      role="button"
      className="mr-10"
      aria-label="Create Quiz"
      onClick={() => setShowCreateModal(true)}
    >
      Create Quiz
    </Button>
  );

  const itemsWithLrnRef = items.map((item) => ({
    ...item,
    item_id: item.itemId,
    learnosity_item_reference: item.accNum,
  }));

  return (
    <Fragment>
      {showCreateModal && (
        <FocusLock group="part-of-screen-modal">
          <CreateModal
            onTitleChange={onTitleChange}
            onCancel={closeCreateModal}
            onCreate={submitCreateModal}
          />
        </FocusLock>
      )}
      <ScreenModal
        hasTitleWithTooltip={false}
        isScrollableContent={false}
        contentWithSpacing={false}
        size="full"
        title={previewTitle}
        subTitle={previewSubTitle}
        topBar={previewTopBar}
        topBarClassName={blueBookUiFlag ? 'min-h-28 bg-bluebook-gray8' : ''}
        onClose={() =>
          router.push({
            pathname: `/${subject}/home`,
            query: omit(query, 'previewItemId'),
          })
        }
      >
        <PreviewItem
          key={previewId}
          displayTags
          isQBCreateTab
          isTopicQuestion
          isSingleQuestionPreview
          blueBookUiFlag={blueBookUiFlag}
          navigationContainerSelector=".lrn-group-middle"
          onItemChange={onItemChange}
          navigation={
            <QuestionNavigation
              onUrlUpdate={onUrlUpdate}
              hasMorePages={false}
              itemsPerPage={0}
              items={itemsWithLrnRef}
              currentPage={0}
              total={items.length}
              location={location}
              params={params}
              router={router}
              pathname="/home/preview/item/"
            />
          }
          itemId={currentPreviewId}
          subjectId={subject}
          itemIds={itemIds}
          itemsWithLrnRef={itemsWithLrnRef}
          showQuestionIndex={false}
          showQuestionBookmark={false}
          showQuestionOverview={false}
          learnosityConfig={questionBankPreviewConfig}
        />
      </ScreenModal>
    </Fragment>
  );
};

TopicQuestionPreview.propTypes = {
  previewId: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  itemIds: PropTypes.array.isRequired,
  router: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  onCreateQuiz: PropTypes.func.isRequired,
  blueBookUiFlag: PropTypes.bool.isRequired,
};

export default TopicQuestionPreview;
